import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    // SelectLabel,
    SelectTrigger,
    SelectValue,
} from '@/shared/components/ui/select'
import { useV2SContext } from './V2SProvider'

const languages = [
    { locale: 'en', label: 'English' },
    { locale: 'ml', label: 'Malayalam' },
]

export function SelectLanguage() {
    const { language, setLanguage } = useV2SContext()

    return (
        <div className="p-4">
            <Select onValueChange={setLanguage} defaultValue={language}>
                <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select a Language" />
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                        {/* <SelectLabel>Language</SelectLabel> */}
                        {languages.map((language) => {
                            return (
                                <SelectItem key={language.locale} value={language.locale}>
                                    {language.label}
                                </SelectItem>
                            )
                        })}
                    </SelectGroup>
                </SelectContent>
            </Select>
        </div>
    )
}
